(ns manage.resource.product
  (:require [common.url :as url]
            [re-frame.core :as rf]))

(rf/reg-event-fx :resource.product/get-one-for-selector
  [(rf/inject-cofx :sub :config)]
  (fn [{:keys [db config]} [_ {:keys [product-id selector-param]}]]
    {:db (assoc-in db [:resource.product/one-for-selector :state] :pending)
     :http
     {:method :get
      :uri (url/parts->str [(:apiUrl config)
                            "products/"
                            product-id])
      :on-success [:resource.product/get-one-for-selector-success selector-param]
      :on-failure [:resource.product/get-one-for-selector-failure selector-param]}}))

(rf/reg-event-db :resource.product/get-one-for-selector-success
  (fn [db [_ selector-param product]]
    (let [new-value (hash-map selector-param product)]
      (assoc db :resource.product/one-for-selector {:state :success
                                                    :value new-value}))))

(rf/reg-event-db :resource.product/get-one-for-selector-failure
  (fn [db [_ _]]
    (assoc db :resource.product/one-for-selector {:state :failure :value nil})))

(rf/reg-event-fx :resource.product/create-store
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [config context] :as cofx} [_ advertiser-id]]
    {:http
     {:method :post
      :uri (url/parts->str [(:apiUrl config) "product-stores"])
      :params {:advertiser-id (or advertiser-id (int (:advertiser-id context)))}
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success [:resource.product/create-store-success (:advertiser-id context)]
      :on-failure [:resource.product/create-store-failure]}}))

(rf/reg-event-fx :resource.product/create-store-success
  (fn []
    {:fx [[:invalidate-query {:queryKey ["product-store"]}]]}))

(rf/reg-event-db :resource.product/create-store-failure
  (fn [db] db))
